import { TrainingProduct } from '../types/trainingCourse'

// Macrocategorie definitive
export const trainingCategories = [
  'Privacy e protezione dati',
  'HACCP e sicurezza alimentare',
  'Sicurezza sul lavoro',
  'Qualità e certificazioni',
  'Sicurezza delle informazioni',
  'Ambiente',
  'Compliance e governance',
  'Servizi digitali',
  'Servizi integrati',
  'Ufficio e amministrazione',
  'Intelligenza artificiale',
] as const

// Tipologie definitive
export const productTypes = [
  'Consulenza',
  'Gestione continuativa/annuale',
  'Incarico/nomina',
  'Documento/elaborato tecnico',
  'Servizio operativo/tecnico',
  'Audit/sopralluogo',
  'Noleggio',
  'Canone/voce ricorrente',
  'Corso/formazione',
  'Aggiornamento formativo/tecnico',
  'Policy/voce non commerciale da confermare',
  'Segnalazione provvigione',
] as const

// Prodotti di esempio: denominazione, tipologia, codice prodotto, macrocategoria
// e anni di validità (provvisori, da sostituire con il database reale)
export const trainingProducts: TrainingProduct[] = [
  { code: 'FOR-FGL', name: 'Formazione generale lavoratori', type: 'Corso/formazione', category: 'Sicurezza sul lavoro' },
  { code: 'FOR-FSB', name: 'Formazione specifica lavoratori rischio basso', type: 'Corso/formazione', category: 'Sicurezza sul lavoro', validityYears: 5 },
  { code: 'FOR-FSM', name: 'Formazione specifica lavoratori rischio medio', type: 'Corso/formazione', category: 'Sicurezza sul lavoro', validityYears: 5 },
  { code: 'FOR-FSA', name: 'Formazione specifica lavoratori rischio alto', type: 'Corso/formazione', category: 'Sicurezza sul lavoro', validityYears: 5 },
  { code: 'FOR-PRE', name: 'Preposto', type: 'Corso/formazione', category: 'Sicurezza sul lavoro', validityYears: 2 },
  { code: 'FOR-DIR', name: 'Dirigente', type: 'Corso/formazione', category: 'Sicurezza sul lavoro', validityYears: 5 },
  { code: 'FOR-RLS', name: 'Rappresentante dei lavoratori (RLS)', type: 'Corso/formazione', category: 'Sicurezza sul lavoro', validityYears: 1 },
  { code: 'FOR-ARL', name: 'Aggiornamento RLS', type: 'Aggiornamento formativo/tecnico', category: 'Sicurezza sul lavoro', validityYears: 1 },
  { code: 'FOR-PSB', name: 'Primo soccorso gruppo B/C', type: 'Corso/formazione', category: 'Sicurezza sul lavoro', validityYears: 3 },
  { code: 'FOR-AI2', name: 'Antincendio livello 2', type: 'Corso/formazione', category: 'Sicurezza sul lavoro', validityYears: 5 },
  { code: 'FOR-CAR', name: 'Carrellisti', type: 'Corso/formazione', category: 'Sicurezza sul lavoro', validityYears: 5 },
  { code: 'FOR-PLE', name: 'Piattaforme di lavoro elevabili (PLE)', type: 'Corso/formazione', category: 'Sicurezza sul lavoro', validityYears: 5 },
  { code: 'FOR-HAC', name: 'HACCP alimentaristi', type: 'Corso/formazione', category: 'HACCP e sicurezza alimentare', validityYears: 2 },
  { code: 'FOR-RDL', name: 'RSPP datore di lavoro', type: 'Corso/formazione', category: 'Sicurezza sul lavoro', validityYears: 5 },
]
